import request from "../request";

export default {

  listAll(data) {
    return request.get("/adminComment/listAll", data);
  },

  delete(data) {
    return request.post("/adminComment/delete", data);
  },

  updateStatus(data) {
    return request.post("/adminComment/updateStatus", data);
  },

};
